import { HCConfig, HCConfigAssets, HCConfigFeatures, HCConfigRules } from './hc-config';

export const sos: HCConfig = {
  appName: 'SOS Portal',
  hcId: '',
  isPublic: false,
  uf: 'PI',
  config: {
    trackingId: 'G-9X9EH06CJM',
    domain: 'app.sosportal.com.br',
    domainKey: 'appDomainUrl',
    reactDomainKey: 'appDomainReactUrl',
    hcParam: 'sos',
    clientDomainHeader: 'sos',
    supportChatKey:
      'ZWIzNjc5MjEtZWNkNy00YzgzLWEyNzctZmUwNTcwNDhhNWEwOmU4YmM0YjQwMjY4NTQ2ODFkZDM1ZDhmMDI3NWRjYTc4YTU2NTg3MjJjZXNwMDA3MG4yZ0FsQ0dzYzExS0lTOE9uejNtY3dvRmg1SzhvRDJqcWc=',
  },

  assets: {
    logo: HCConfigAssets.mainLogo('sos'),
    uploadExternalFilesLogo: HCConfigAssets.uploadExternalFilesLogo('sos', 'upload-external-files-logo.svg'),
    preloaderLogo: HCConfigAssets.preloaderLogo('sos', 'preloader-logo.svg'),
    favicon: HCConfigAssets.favicon('sos', 'favicon.ico'),
  },
  links: {
    site: 'https://app.sosportal.com.br',
    termsOfUse: 'https://files.sosportal.com.br/termos-de-uso.html',
    policyPrivacy: 'https://files.sosportal.com.br/politica-de-privacidade.html',
    playstore: 'https://play.google.com/store/apps/details?id=com.ptm.sosportal',
    appstore: 'https://apps.apple.com/br/app/isalut/id1506057413',
  },
  dataDeletion: {
    name: 'SOS Portal',
    slug: 'sosPortal',
    agreementTermsUrl: 'https://files.sosportal.com.br/termo-de-consentimento-exclusao-conta.html',
    background: '#ffffff',
    logo: {
      src: HCConfigAssets.dataDeletionLogo('sos'),
      width: 281,
      height: 180,
    },
  },
  firstAccess: {
    name: 'SOS Portal',
    slug: 'sos-portal',
    abbreviation: 'sos',
    background:
      'linear-gradient(290.88deg, rgba(8, 15, 58, 0.17) 0%, rgba(8, 15, 58, 0) 100%), linear-gradient(168.82deg, #0e9ae6 0%, rgba(7, 95, 199, 0.79) 100%)',
    logo: {
      src: HCConfigAssets.firstAccessLogo('sos', 'logo-with-strains.svg'),
      width: 274,
      height: 180,
    },
  },

  mealPlan: {
    enableDocumentCreation: false,
    enableSendFiles: true,
    documentTypes: {
      showMealPlan: true,
      showTherapeuticPlan: false,
      showNursingPlan: false,
    },
  },

  routes: {
    firstAccess: '',
  },
  features: [
    HCConfigFeatures.HC_ADM_CAN_CHANGE_PATIENT_PASSWORD,
    HCConfigFeatures.CAMERA_MIC_PREVIEW_BEFORE_CALL_JOIN,
  ],
  rules: [
    HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_EMAIL,
    HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_CPF,
    HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_EMAIL,
    HCConfigRules.PHYSICIAN_SIGNATURE_STATUS_WIDGET,
    HCConfigRules.DOCTORS_LIST_SHOW_DIGITAL_SIGNATURE_STATUS,
  ],
};
